import React from "react";
import PropTypes from "prop-types";
import { FormControlLabel, Switch, Tooltip } from "@mui/material";

/**
 * The v1 <-> v2 switch. Controlled: the host page decides what flipping
 * does (the Audit History page swaps its content in place; the standalone
 * /beta route navigates back to production).
 */
export const Cap2ViewToggle = ({ checked, onChange }) => (
  <Tooltip
    title={
      checked
        ? "Back to production screening"
        : "Preview CAP 2.0 (AA-LLM) shadow screening - nothing is written " +
          "to the CAP system of record"
    }
  >
    <FormControlLabel
      data-testid="cap2-beta-entry"
      sx={{ ml: 0 }}
      control={
        <Switch
          size="small"
          color="secondary"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          inputProps={{ "data-testid": "cap2-view-toggle" }}
        />
      }
      label="CAP 2.0 (Beta)"
    />
  </Tooltip>
);

Cap2ViewToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Cap2ViewToggle;
